import { render, staticRenderFns } from "./CreatorServicePurchaseCard.vue?vue&type=template&id=ba4d52e4&scoped=true&"
import script from "./CreatorServicePurchaseCard.vue?vue&type=script&lang=ts&"
export * from "./CreatorServicePurchaseCard.vue?vue&type=script&lang=ts&"
import style0 from "./CreatorServicePurchaseCard.vue?vue&type=style&index=0&id=ba4d52e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4d52e4",
  null
  
)

export default component.exports